import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import useAuth from '~/utils/auth/useAuth'

const useCustom = () => {
  const { idmRoutesUsers } = useAuth()

  const location = useLocation()
  const history = useHistory()

  const tabMenus = useMemo(() => {
    return idmRoutesUsers
      .filter((route) => route.shownOnTab && !route.disabled)
      .map((route) => ({
        id: route.id,
        title: route.title,
        path: route.defaultPath,
        icon: `/public/icons/${route.id}.png`,
      }))
  }, [])

  const handleChangeTab = (event, newValue) => {
    const selectedRoute = tabMenus.find((route) => route.id === newValue)
    history.push(selectedRoute.path)
  }

  const currentTab = useMemo(() => {
    return (
      tabMenus.find((route) => location.pathname.includes(route.id))?.id ||
      tabMenus[0].id
    )
  }, [tabMenus, location.pathname])

  return { tabMenus, handleChangeTab, currentTab }
}

export default useCustom
